import { Button, Divider, Grid, IconButton, Paper, Typography } from "@mui/material";
import React from "react";
import WSSCheckBoxField from "../../Components/CheckBox/WSCheckBox";
import { WSIcons } from "../../commonFunctions/iIcons";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";

export const TaxesGst:React.FC<any>=React.memo((props)=>{
      const { control, register, handleSubmit, setValue, reset, watch } = useForm();
    
    const navigate = useNavigate()
     const handleCancelClick = () => {
    navigate("/");
  };
    return(
         <Grid p={2}>
      <Paper sx={{ padding: 3, position: "relative" }} elevation={0}>
        {/* Close Icon in top right */}
        <IconButton
          size="small"
          sx={{ position: "absolute", top: 8, right: 8 }}
          onClick={handleCancelClick} // replace with your close logic
        >
          <WSIcons.CloseIcon fontSize="small" />
        </IconButton>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography fontWeight={"bold"}>GST Settings</Typography>
                <Divider />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Enable GST"
                  id="enableGST"
                  control={control}
                  {...register("enableGST")}
                  rules={{ required: false }}
                  name="enableGST"
                />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Enable HSN/SAC Code"
                  id="enableHSNCode"
                  control={control}
                  {...register("enableHSNCode")}
                  rules={{ required: false }}
                  name="enableHSNCode"
                />
              </Grid>
               <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Additional Cess On Item"
                  id="AdditionalCessOnItem"
                  control={control}
                  {...register("AdditionalCessOnItem")}
                  rules={{ required: false }}
                  name="AdditionalCessOnItem"
                />
              </Grid>
                <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Reverse Charge"
                  id="reverseCharge"
                  control={control}
                  {...register("reverseCharge")}
                  rules={{ required: false }}
                  name="reverseCharge"
                />
              </Grid>
               <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Enable Place of Supply"
                  id="enablePlaceofSupply"
                  control={control}
                  {...register("enablePlaceofSupply")}
                  rules={{ required: false }}
                  name="enablePlaceofSupply"
                />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Composite Scheme"
                  id="CompositeScheme"
                  control={control}
                  {...register("CompositeScheme")}
                  rules={{ required: false }}
                  name="CompositeScheme"
                />
              </Grid>
               <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Enable TCS"
                  id="enableTCS"
                  control={control}
                  {...register("enableTCS")}
                  rules={{ required: false }}
                  name="enableTCS"
                />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Enable TDS"
                  id="enableTDS"
                  control={control}
                  {...register("enableTDS")}
                  rules={{ required: false }}
                  name="enableTDS"
                />
              </Grid>
              <Grid item xs={12}>
                <Button>
                    Tax List <WSIcons.ArrowRight/>
                </Button>
              </Grid>
              </Grid>
              </Grid>
              </Grid>
              </Paper>
              </Grid>
              
    )
})